var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DashboardEditSection',{staticClass:"SubscriptionForm",attrs:{"title":"Billing"}},[_c('h2',[_vm._v("Payment methods")]),_c('ManageCreditCards'),_c('h2',[_vm._v("Your plan")]),_c('BillingPlan',{attrs:{"drivers":5}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }